import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import StatusMappingsEditor from './components/StatusMappingsEditor';

const ImportStatusMappings = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Status Mappings</h3>
        <h3 className="page-subhead subhead">
          <Link className="" to="/">Home</Link>
          &nbsp;/ {'Status Mappings'}
        </h3>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <StatusMappingsEditor />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>
);

export default ImportStatusMappings;
